<div class="details">
  <div class="recipeImage">
    <img src="assets/categories/juice.jpg" alt="" />
  </div>
  <div class="recipeName">Baked chicken burger</div>
  <div class="recipeCounts">
    <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
    <div class="chat">
      <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
    </div>
    <div class="ratings"><ion-icon name="star-outline"></ion-icon> 203</div>
  </div>
  <div class="recipeDescription">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam elementum
    justo vitae erat suscipit mollis. Donec eleifend suscipit venenatis.
    Pellentesque aliquam aliquam consectetur. Vivamus volutpat purus ut
    elementum bibendum.
  </div>
  <div class="recipeValues">
    <div>
      <div>14 cal</div>
      <div>Calories</div>
    </div>
    <div>
      <div>45 min</div>
      <div>Time</div>
    </div>
    <div>
      <div>1 person</div>
      <div>Portion</div>
    </div>
  </div>
  <div class="section ingredients">
    <div class="label">Ingredients</div>
    <div class="content">
      <div>
        <div>Chicken</div>
        <div>4kg</div>
      </div>
      <div>
        <div>Bacon</div>
        <div>16 slices</div>
      </div>
      <div>
        <div>Maple syrup</div>
        <div>1 teaspoon</div>
      </div>
      <div>
        <div>Bacon</div>
        <div>16 slices</div>
      </div>
      <div>
        <div>Maple syrup</div>
        <div>1 teaspoon</div>
      </div>
      <div>
        <div>Bacon full</div>
        <div>16 slices</div>
      </div>
      <div>
        <div>Maple syrup full bottle</div>
        <div>1 teaspoon</div>
      </div>
      <div>
        <div>Salad</div>
        <div>100 g</div>
      </div>
      <div>
        <div>Chicken</div>
        <div>4kg</div>
      </div>
      <div>
        <div>Bacon</div>
        <div>16 slices</div>
      </div>
      <div>
        <div>Maple syrup</div>
        <div>1 teaspoon</div>
      </div>
      <div>
        <div>Bacon</div>
        <div>16 slices</div>
      </div>
      <div>
        <div>Maple syrup</div>
        <div>1 teaspoon</div>
      </div>
      <div>
        <div>Bacon full</div>
        <div>16 slices</div>
      </div>
      <div>
        <div>Maple syrup full bottle</div>
        <div>1 teaspoon</div>
      </div>
      <div>
        <div>Salad</div>
        <div>100 g</div>
      </div>
    </div>
  </div>
  <div class="section steps">
    <div class="label">Steps</div>
    <div class="content">
      <div>
        <div class="step">Step 1 : <span>Take full bottle of water</span></div>
        <div class="desc">
          Proin sagittis magna in tortor pharetra rutrum. Ut ultrices massa nec
          nisl tempus, sit amet interdum turpis convallis. In odio tellus,
          tempus ac nisl vitae, sagittis hendrerit sapien. Morbi consequat purus
          non tortor aliquet pharetra. Etiam sodales justo ac nulla consequat
          aliquam. Vivamus aliquam turpis ex, vel luctus dui fermentum ac.
          Integer mattis augue dolor, nec semper nisi mollis sed. Vivamus
          blandit, sapien ut vulputate tristique, est sapien pretium elit, at
          scelerisque sem odio vel enim.
        </div>
      </div>
      <div>
        <div class="step">Step 2 : <span>Take full bottle of water</span></div>
        <div class="desc">
          Aliquam erat volutpat. Etiam laoreet finibus nulla, non varius dolor
          laoreet ut. Duis placerat euismod pharetra. Sed suscipit id eros quis
          facilisis. Curabitur consequat, ex et congue placerat, arcu lorem
          mattis dui, eget mollis est enim et ipsum. Aenean ornare imperdiet mi
          ac fringilla. Interdum et malesuada fames ac ante ipsum primis in
          faucibus.
        </div>
      </div>
      <div>
        <div class="step">Step 3 : <span>Take full bottle of water</span></div>
        <div class="desc">
          Suspendisse at congue neque, quis fringilla justo. In vel lectus vel
          massa malesuada pulvinar fermentum vitae enim. Sed id orci ut metus
          bibendum ullamcorper. Sed sollicitudin eget sapien a vulputate.
          Curabitur eget purus metus. Pellentesque nec leo non tellus rutrum
          imperdiet ac sit amet ipsum. Vivamus quis quam id nisl mattis molestie
          a nec dolor. Quisque ullamcorper consectetur eros. Nullam a est
          mattis, aliquet libero quis, hendrerit lorem.
        </div>
      </div>
      <div>
        <div class="step">Step 4 : <span>Take full bottle of water</span></div>
        <div class="desc">
          Proin sagittis magna in tortor pharetra rutrum. Ut ultrices massa nec
          nisl tempus, sit amet interdum turpis convallis. In odio tellus,
          tempus ac nisl vitae, sagittis hendrerit sapien. Morbi consequat purus
          non tortor aliquet pharetra. Etiam sodales justo ac nulla consequat
          aliquam. Vivamus aliquam turpis ex, vel luctus dui fermentum ac.
          Integer mattis augue dolor, nec semper nisi mollis sed. Vivamus
          blandit, sapien ut vulputate tristique, est sapien pretium elit, at
          scelerisque sem odio vel enim.
        </div>
      </div>
      <div>
        <div class="step">Step 5 : <span>Take full bottle of water</span></div>
        <div class="desc">
          Aliquam erat volutpat. Etiam laoreet finibus nulla, non varius dolor
          laoreet ut. Duis placerat euismod pharetra. Sed suscipit id eros quis
          facilisis. Curabitur consequat, ex et congue placerat, arcu lorem
          mattis dui, eget mollis est enim et ipsum. Aenean ornare imperdiet mi
          ac fringilla. Interdum et malesuada fames ac ante ipsum primis in
          faucibus.
        </div>
      </div>
      <div>
        <div class="step">Step 6 : <span>Take full bottle of water</span></div>
        <div class="desc">
          Suspendisse at congue neque, quis fringilla justo. In vel lectus vel
          massa malesuada pulvinar fermentum vitae enim. Sed id orci ut metus
          bibendum ullamcorper. Sed sollicitudin eget sapien a vulputate.
          Curabitur eget purus metus. Pellentesque nec leo non tellus rutrum
          imperdiet ac sit amet ipsum. Vivamus quis quam id nisl mattis molestie
          a nec dolor. Quisque ullamcorper consectetur eros. Nullam a est
          mattis, aliquet libero quis, hendrerit lorem.
        </div>
      </div>
    </div>
  </div>
  <div class="section actions">
    <div class="content">
      <div class="recipeMiniImage">
        <img src="assets/categories/juice.jpg" alt="" />
      </div>
      <div>
        <div class="title">Do you like this recipe?</div>
        <div class="desc">
          Give a like to the creator and show your support.
        </div>
        <div class="wrapper">
          <button>
            <div><ion-icon name="heart-outline"></ion-icon></div>
            <div>Awesome</div>
          </button>
          <button>
            <div><ion-icon name="bookmark-outline"></ion-icon></div>
            <div>Bookmark</div>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="section recipeBy">
    <div class="label">Recipe by</div>
    <div class="content">
      <div class="userIcon">
        <div class="cover">
          <img src="assets/user.jpg" alt="" />
          <!-- <div class="empty">T</div> -->
        </div>
        <div class="info">
          <div class="name">John wick</div>
          <div class="tagline">Chef</div>
        </div>
      </div>
      <div class="userDesc"></div>
    </div>
  </div>
  <div class="section reviews">
    <div class="label">Reviews</div>
    <div class="content">
      <div>
        <div class="box">
          <div class="main">
            <div class="number">4.7</div>
            <div class="stars">
              <ion-icon name="star-outline"></ion-icon>
              <ion-icon name="star-outline"></ion-icon>
              <ion-icon name="star-outline"></ion-icon>
              <ion-icon name="star-outline"></ion-icon>
              <ion-icon name="star-outline"></ion-icon>
            </div>
            <div class="desc">128 reviews</div>
          </div>
          <div class="meter">
            <div>
              <div>5</div>
              <div class="progress"></div>
              <div>10%</div>
              <div>12</div>
            </div>
            <div>
              <div>4</div>
              <div class="progress"></div>
              <div>10%</div>
              <div>12</div>
            </div>
            <div>
              <div>3</div>
              <div class="progress"></div>
              <div>10%</div>
              <div>12</div>
            </div>
            <div>
              <div>2</div>
              <div class="progress"></div>
              <div>10%</div>
              <div>12</div>
            </div>
            <div>
              <div>1</div>
              <div class="progress"></div>
              <div>10%</div>
              <div>12</div>
            </div>
          </div>
        </div>
        <div class="editor">
          <div>Your review</div>
          <div>
            <ion-icon name="star-outline"></ion-icon>
            <ion-icon name="star-outline"></ion-icon>
            <ion-icon name="star-outline"></ion-icon>
            <ion-icon name="star-outline"></ion-icon>
            <ion-icon name="star-outline"></ion-icon>
          </div>
          <div>
            <textarea ></textarea>
          </div>
          <div class="action">
            <button>Submit</button>
          </div>
        </div>
      </div>
      <div class="reviews">
        <div class="review">
          <div class="header">
            <div class="userIcon">
              <div class="cover">
                <div class="empty">T</div>
              </div>
              <div class="info">
                <div class="name">John wick</div>
                <div class="tagline">Chef</div>
              </div>
            </div>
            <div class="meta">
              <div class="stars">
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
              </div>
              <div class="estimate">3 days ago</div>
            </div>
          </div>

          <div class="longMessage">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            elementum justo
          </div>
        </div>
        <div class="review">
          <div class="header">
            <div class="userIcon">
              <div class="cover">
                <div class="empty">T</div>
              </div>
              <div class="info">
                <div class="name">John wick</div>
                <div class="tagline">Chef</div>
              </div>
            </div>
            <div class="meta">
              <div class="stars">
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
              </div>
              <div class="estimate">3 days ago</div>
            </div>
          </div>

          <div class="longMessage">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            elementum justo
          </div>
        </div>
        <div class="review">
          <div class="header">
            <div class="userIcon">
              <div class="cover">
                <div class="empty">T</div>
              </div>
              <div class="info">
                <div class="name">John wick</div>
                <div class="tagline">Chef</div>
              </div>
            </div>
            <div class="meta">
              <div class="stars">
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
                <ion-icon name="star-outline"></ion-icon>
              </div>
              <div class="estimate">3 days ago</div>
            </div>
          </div>

          <div class="longMessage">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            elementum justo
          </div>
        </div>
        <div class="actions">
          <button>See all 463 reviews</button>
        </div>
      </div>
    </div>
  </div>
  <div class="section comments">
    <div class="label">Comments</div>
    <div class="content">
      <div class="comment">
        <div class="data">
          <div class="header">
            <div class="userIcon">
              <div class="cover">
                <div class="empty">T</div>
              </div>
              <div class="info">
                <div class="name">John wick</div>
                <div class="tagline">Chef</div>
              </div>
            </div>
            <div class="date">5 days ago</div>
          </div>
          <div class="message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            elementum justo vitae erat suscipit mollis.
          </div>
        </div>
        <div class="replies">
          <div class="comment">
            <div class="data">
              <div class="header">
                <div class="userIcon">
                  <div class="cover">
                    <img src="assets/user.jpg" alt="" />
                  </div>
                  <div class="info">
                    <div class="name">John wick</div>
                    <div class="tagline">Chef</div>
                  </div>
                </div>
                <div class="date">5 days ago</div>
              </div>
              <div class="message">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
                elementum justo vitae erat suscipit mollis.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="comment">
        <div class="data">
          <div class="header">
            <div class="userIcon">
              <div class="cover">
                <div class="empty">T</div>
              </div>
              <div class="info">
                <div class="name">John wick</div>
                <div class="tagline">Chef</div>
              </div>
            </div>
            <div class="date">5 days ago</div>
          </div>
          <div class="message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            elementum justo vitae erat suscipit mollis.
          </div>
        </div>
      </div>
      <div class="comment">
        <div class="data">
          <div class="header">
            <div class="userIcon">
              <div class="cover">
                <div class="empty">T</div>
              </div>
              <div class="info">
                <div class="name">John wick</div>
                <div class="tagline">Chef</div>
              </div>
            </div>
            <div class="date">5 days ago</div>
          </div>
          <div class="message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            elementum justo vitae erat suscipit mollis.
          </div>
        </div>
      </div>
      <div class="comment">
        <div class="data">
          <div class="header">
            <div class="userIcon">
              <div class="cover">
                <div class="empty">T</div>
              </div>
              <div class="info">
                <div class="name">John wick</div>
                <div class="tagline">Chef</div>
              </div>
            </div>
            <div class="date">5 days ago</div>
          </div>
          <div class="message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            elementum justo vitae erat suscipit mollis.
          </div>
        </div>
      </div>
      <div class="composer">
        <textarea></textarea>
        <div class="actions">
          <div>10/100</div>
          <button>Post</button>
        </div>
      </div>
    </div>
  </div>
  <div class="section related">
    <div class="label">Related recipes</div>
    <div class="content">
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/fried_rice.jpg" alt="" />
        </div>
        <div class="wrapper">
          <div class="info">
            <div class="name">Unique Chicken Biryani Recipe</div>
            <div class="calories">42 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>55 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>2 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/pizza.jpg" alt="" />
        </div>
        <div class="wrapper">
          <div class="info">
            <div class="name">Cheese Pizza</div>
            <div class="calories">14 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>45 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>3 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/juice.jpg" alt="" />
        </div>
        <div class="wrapper">
          <div class="info">
            <div class="name">New York Cheesecake Recipe</div>
            <div class="calories">33 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>32 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>1 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/pizza.jpg" alt="" />
        </div>
        <div class="wrapper">
          <div class="info">
            <div class="name">Cheese Pizza</div>
            <div class="calories">14 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>45 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>3 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
    </div>
  </div>
</div>
